import { useNavigate } from "react-router-dom";
import { INews } from "types/news"
import { ReactComponent as Nodata } from 'assets/news/nodata.svg'
import { stripHtml } from "components/function";
import { motion } from 'framer-motion'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY } from "components/constants/animation-properties";

interface ICard {
    item: INews
    idx: number
}

const Card = ({ item }: ICard) => {
    const navigate = useNavigate();

    const goDetail = () => {
        navigate(`/news/detail?id=${item.id}`)
    }

    return (
        <motion.div
            className={`group flex flex-col text-sm bg-white rounded-xl cursor-pointer shadow-lg`}
            onClick={goDetail}
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
        >
            <div className='rounded-t-xl h-[260px] overflow-hidden'>
                {
                    (item.thumbnail !== null && !item.thumbnail.includes('cid')) ?
                        <img
                            className='w-full h-full object-cover group-hover:scale-105 transition-all'
                            src={item.thumbnail}
                            alt=""
                        /> :
                        <div className='flex justify-center items-center w-full h-full'>
                            <Nodata />
                        </div>
                }
            </div>
            <div className={`flex items-center border-b border-b-[#F8F8FA] px-6 py-5 gap-20`}>
                <p className='flex-[3] font-semibold text-base text-left truncate'>{item.title}</p>
            </div>
            <div className="px-6 py-3 border-b border-b-[#F8F8FA] text-[#9D9EB7] text-sm">
                <p className='h-20 clamp-4'>
                    {stripHtml(item.content)}
                </p>
            </div>
            <div className='flex justify-between items-center px-6 py-3 text-xs'>
                <p className='font-semibold'>
                    {item.createAt}
                </p>
                <p className='text-primary'>상세보기</p>
            </div>
        </motion.div>
    )
}

export default Card